import { render, staticRenderFns } from "./ChipRound.vue?vue&type=template&id=4aef1d5a&scoped=true&"
import script from "./ChipRound.vue?vue&type=script&lang=js&"
export * from "./ChipRound.vue?vue&type=script&lang=js&"
import style0 from "./ChipRound.vue?vue&type=style&index=0&id=4aef1d5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aef1d5a",
  null
  
)

export default component.exports